module.exports = __webpack_public_path__ + "static/media/main-movie-grid-empty-bg.164c968b.png";